import { mutate } from "lib/graphql/mutate"
import { api } from "lib/graphql/api.js"
import { gql } from "@apollo/client"

export const healTaskAuditStatus = api(async function healTaskAuditStatus({ auditId, superseding }) {
    return await mutate(
        gql`
            mutation HealTaskAuditStatus($auditId: String!, $superseding: Boolean!) {
                healTaskAuditStatus(auditId: $auditId, superseding: $superseding)
            }
        `,
        { auditId, superseding },
        { returns: "healTaskAuditStatus" }
    )
})
